<template>
  <v-card min-height="550">
    <v-row width="100%">
      <v-col cols="6">
        <v-card class="pa-2 green2 elevation-0">
          <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
          <v-list class="green2">
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-subtitle class="text-capitalize"
                  >{{$t('animal.performanceInfo.currentWeight')}}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <span>{{$t('animal.performanceInfo.weightAnimal')}}</span>
                  </v-tooltip>
                </v-list-item-subtitle>
                <v-list-item-title class="text-h6 mt-2">
                  <div class="text-h6 font-weight-bolder">
                    {{ animal.currentWeight }}<span class="ml-2 text-h6 font-weight-light">{{ animal.currentWeightUom }}</span>
                  </div>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-list-item-subtitle
            class="
              mt-n6
              mb-n2
              text-overline
              font-weight-light
              text-end text--secondary
            "
            >26/06/2021</v-list-item-subtitle
          >
        </v-card>
      </v-col>
      <v-col cols="6" v-if="(currentAnimal.animalRemovalReason != 'sale')">
        <v-card class="pa-2 green2 elevation-0">
          <v-icon class="float-right">mdi-dots-horizontal
            
          </v-icon>
          <v-list class="green2">
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-subtitle class="text-capitalize"
                  >{{$t('animal.performanceInfo.postWeaningGain')}}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <span>{{$t('animal.performanceInfo.dailyGainInAnimalWeightWeaning')}}</span>
                  </v-tooltip>
                </v-list-item-subtitle>
                <v-list-item-title class="text-h6 mt-2">
                  <div class="text-h6 font-weight-bolder">
                    {{ animal.postWeaningGain
                    }}<span class="ml-2 text-h6 font-weight-light">{{ animal.postWeaningGainUom
                    }}</span>
                  </div>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-list-item-subtitle
            class="
              mt-n6
              mb-n2
              text-overline
              font-weight-light
              text-end text--secondary
            "
            >.</v-list-item-subtitle
          >
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card class="pa-2 green2 elevation-0">
          <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
          <v-list class="green2">
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-subtitle class="text-capitalize"
                  >{{$t('animal.performanceInfo.weaningWeight')}}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <span>{{$t('animal.performanceInfo.weightAnimalMeasuredWeaning')}}</span>
                  </v-tooltip>
                </v-list-item-subtitle>
                <v-list-item-title class="text-h6 mt-2">
                  <div class="text-h6 font-weight-bolder">
                    {{ animal.weaningWeight}}<span class="ml-2 text-h6 font-weight-light">{{ animal.weaningWeightUom }}</span>
                  </div>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-list-item-subtitle
            class="
              mt-n6
              mb-n2
              text-overline
              font-weight-light
              text-end text--secondary
            "
            >.</v-list-item-subtitle
          >
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card class="pa-2 green2 elevation-0">
          <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
          <v-list class="green2">
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-subtitle class="text-capitalize"
                  >{{$t('animal.performanceInfo.averageDailyGain')}}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <span
                      >{{$t('animal.performanceInfo.averageAmountWeightAnimalGainFeedingPeriod')}}</span
                    >
                  </v-tooltip>
                </v-list-item-subtitle>
                <v-list-item-title class="text-h6 mt-2">
                  <div class="text-h6 font-weight-bolder">
                    {{ animal.avgDailyGain
                    }}<span class="ml-2 text-h6 font-weight-light">{{ animal.avgDailyGainUom
                    }}</span>
                  </div>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-list-item-subtitle
            class="
              mt-n6
              mb-n2
              text-overline
              font-weight-light
              text-end text--secondary
            "
            >.</v-list-item-subtitle
          >
        </v-card>
      </v-col>
      <v-col cols="6" v-if="(currentAnimal.animalRemovalReason != 'sale')">
        <v-card class="pa-2 green2 elevation-0">
          <v-icon class="float-right">mdi-dots-horizontal</v-icon>
          <v-list class="green2">
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-subtitle class="text-capitalize"> {{$t('animal.performanceInfo.carcassWeight')}}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <span>{{$t('animal.performanceInfo.weightAnimalsHideInternalOrgansRemoved')}}</span>
                  </v-tooltip>
                </v-list-item-subtitle>
                <v-list-item-title class="text-h6 mt-2">
                  <div class="text-h6 font-weight-bolder">
                    {{ animal.carcasWeight }}<span class="ml-2 text-h6 font-weight-light">{{ animal.carcasWeightUom }}</span>
                  </div>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-list-item-subtitle
            class="
              mt-n6
              mb-n2
              text-overline
              font-weight-light
              text-end text--secondary
            "
            >.</v-list-item-subtitle
          >
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card class="pa-2 green2 elevation-0">
          <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
          <v-list class="green2">
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-subtitle class="text-capitalize"
                  >{{$t('animal.performanceInfo.weightAtCalving')}}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <span>{{$t('animal.performanceInfo.weightAtTheTimeOfCalving')}}</span>
                  </v-tooltip>
                </v-list-item-subtitle>
                <v-list-item-title class="text-h6 mt-2">
                  <div class="text-h6 font-weight-bolder">
                    {{ animal.weightAtCalving  }}<span class="ml-2 text-h6 font-weight-light">{{ animal.weightAtCalvingUom }}</span>
                  </div>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-list-item-subtitle
            class="
              mt-n6
              mb-n2
              text-overline
              font-weight-light
              text-end text--secondary
            "
            >.</v-list-item-subtitle
          >
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card class="pa-2 green2 elevation-0">
          <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
          <v-list class="green2">
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-subtitle class="text-capitalize"
                  >{{$t('animal.performanceInfo.yearlingWeight')}}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <span>{{$t('animal.performanceInfo.weightYearOldAnimal')}}</span>
                  </v-tooltip>
                </v-list-item-subtitle>
                <v-list-item-title class="text-h6 mt-2">
                  <div class="text-h6 font-weight-bolder">
                    {{ animal.yearlingWeight
                    }}<span class="ml-2 text-h6 font-weight-light">{{ animal.yearlingWeightUom }}</span>
                  </div>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-list-item-subtitle
            class="
              mt-n6
              mb-n2
              text-overline
              font-weight-light
              text-end text--secondary
            "
            >.</v-list-item-subtitle
          >
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>
<script>
export default {
  mounted(){
    // console.log('aaaa', this.currentAnimal)
  },
  props: ["animal", "currentAnimal"],
};
</script>